import { render, staticRenderFns } from "./JoinList.vue?vue&type=template&id=7c8f2664&scoped=true&"
import script from "./JoinList.vue?vue&type=script&lang=js&"
export * from "./JoinList.vue?vue&type=script&lang=js&"
import style0 from "./JoinList.vue?vue&type=style&index=0&id=7c8f2664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8f2664",
  null
  
)

export default component.exports